import type { EnterpriseI } from 'types';
import { BaseApi } from './base-api';
import { fetchData } from 'Utils/fetch-data';

class EnterpriseApi extends BaseApi<EnterpriseI> {
  /**
   * Actualiza un enterprise en específico.
   * @param id - id del enterprise
   * @param data - la nueva información que tendra el enterprise.
   * @returns - { success: boolean } indicando el resultado
   */
  async patch(id: string, data: Partial<EnterpriseI>) {
    const response = await fetchData<{ success: boolean }>(`${this.endpoint}/${id}`, {
      method: 'PATCH',
      data,
    });
    return response;
  }
}

const enterpriseApi = new EnterpriseApi('/enterprise');

export default enterpriseApi;
